import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, Typography } from "antd";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/modules/attendance-app/context/ThemeContext";
import { useLogin } from "../hooks/useAuth";
import type { LoginRequest } from "../types";

const { Title, Text } = Typography;

export function LoginForm() {
	const [form] = Form.useForm<LoginRequest>();
	const { mutate: login, isPending } = useLogin();
	const { isDark, toggleTheme } = useTheme();

	const onFinish = (values: LoginRequest) => {
		login({
			...values,
			username: values.username.trim(),
		});
	};

	return (
		<Card
			className="w-full max-w-md shadow-lg"
			style={{
				position: "relative",
				background: "var(--app-surface)",
				borderColor: "var(--app-border)",
			}}
		>
			<button
				type="button"
				onClick={toggleTheme}
				title={isDark ? "Light mode" : "Dark mode"}
				style={{
					position: "absolute",
					top: 16,
					right: 16,
					width: 36,
					height: 36,
					borderRadius: "50%",
					border: "none",
					background: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
					color: isDark ? "#FBBF24" : "#6B7280",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					cursor: "pointer",
					transition: "background 0.2s",
				}}
			>
				{isDark ? <Sun size={18} /> : <Moon size={18} />}
			</button>
			<div className="text-center mb-8">
				<Title level={2} className="!mb-2">
					M University
				</Title>
				<Text type="secondary">Hisobingizga kiring</Text>
			</div>

			<Form
				form={form}
				name="login"
				onFinish={onFinish}
				layout="vertical"
				requiredMark={false}
				size="large"
			>
				<Form.Item
					name="username"
					label="Foydalanuvchi nomi"
					rules={[
						{ required: true, message: "Foydalanuvchi nomini kiriting" },
						{ max: 100, message: "Foydalanuvchi nomi 100 ta belgidan oshmasligi kerak" },
					]}
				>
					<Input
						prefix={<UserOutlined className="text-gray-400" />}
						placeholder="admin"
						autoComplete="username"
						maxLength={100}
					/>
				</Form.Item>

				<Form.Item
					name="password"
					label="Parol"
					rules={[
						{ required: true, message: "Parolni kiriting" },
						{ min: 6, message: "Parol kamida 6 ta belgidan iborat bo'lishi kerak" },
					]}
				>
					<Input.Password
						prefix={<LockOutlined className="text-gray-400" />}
						placeholder="Parol"
						autoComplete="current-password"
					/>
				</Form.Item>

				<Form.Item className="!mb-0">
					<Button type="primary" htmlType="submit" loading={isPending} block>
						Tizimga kirish
					</Button>
				</Form.Item>
			</Form>
		</Card>
	);
}
